import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import {
  ExerciseResponse,
  CalendarResponse,
  PetitionResponse,
  DriverResponse,
  DriverProfileResponse,
  Operative,
  ExerciseOperativeAssignment,
  OperativeWeekConfigsResponse,
  SyncWeekConfigsResponse,
  DriverAssignmentResponse,
} from '../../interfaces/holidays.interface';

@Injectable({
  providedIn: 'root',
})
export class HolidaysService {
  constructor(private apiService: ApiService) {}

  getExercises(mock: boolean = false): Observable<ExerciseResponse[]> {
    const path = mock
      ? '/holidays/exercises/?mock=true'
      : '/holidays/exercises/';
    return this.apiService.buildAPIGet<ExerciseResponse[]>(path);
  }

  getExerciseById(
    id: number,
    mock: boolean = false
  ): Observable<ExerciseResponse> {
    const path = mock
      ? `/holidays/exercises/${id}/?mock=true`
      : `/holidays/exercises/${id}/`;
    return this.apiService.buildAPIGet<ExerciseResponse>(path);
  }

  getOperatives(mock: boolean = false): Observable<any[]> {
    const path = mock
      ? '/holidays/operativas/?mock=true'
      : '/holidays/operativas/';
    return this.apiService.buildAPIGet<any[]>(path);
  }

  updateExercise(id: number, data: any): Observable<any> {
    const path = `/holidays/exercises/`;
    return this.apiService.buildAPIPut<any>(path, id, data);
  }

  getExerciseOperatives(id: number): Observable<ExerciseOperativeAssignment> {
    const path = `/holidays/exercises/${id}/operatives/`;
    return this.apiService.buildAPIGet<ExerciseOperativeAssignment>(path);
  }

  postExerciseOperatives(data: any, id: number): Observable<any> {
    const path = `/holidays/operativa-assignments/`;
    return this.apiService.buildAPIPost<any>(path, data);
  }

  unassignExerciseOperative(id: number): Observable<any> {
    const path = `/holidays/operativa-assignments/${id}/unassign/`;
    return this.apiService.buildAPIPost<any>(path, {});
  }

  getOperativeById(id: number, mock: boolean = false): Observable<Operative> {
    const path = mock
      ? `/holidays/operativas/${id}/?mock=true`
      : `/holidays/operativas/${id}/`;
    return this.apiService.buildAPIGet<Operative>(path);
  }

  getOperativeCalendar(
    id: number,
    mock: boolean = false
  ): Observable<CalendarResponse> {
    const path = mock
      ? `/holidays/operativas/${id}/calendar/?mock=true`
      : `/holidays/operativas/${id}/calendar/`;
    return this.apiService.buildAPIGet<CalendarResponse>(path);
  }

  getOperativeRequests(
    id: number,
    mock: boolean = false
  ): Observable<PetitionResponse[]> {
    const path = mock
      ? `/holidays/operativas/${id}/requests/?mock=true`
      : `/holidays/operativas/${id}/requests/`;
    return this.apiService.buildAPIGet<PetitionResponse[]>(path);
  }

  getOperativeDrivers(
    id: number,
    mock: boolean = false
  ): Observable<DriverResponse[]> {
    const path = mock
      ? `/holidays/operativas/${id}/drivers/?mock=true`
      : `/holidays/operativas/${id}/drivers/`;
    return this.apiService.buildAPIGet<DriverResponse[]>(path);
  }

  getDriverProfile(
    id: number,
    mock: boolean = false
  ): Observable<DriverProfileResponse> {
    const path = mock
      ? `/holidays/drivers/${id}/data/?mock=true`
      : `/holidays/drivers/${id}/data/`;
    return this.apiService.buildAPIGet<DriverProfileResponse>(path);
  }

  changeExerciseActiveStatus(id: number, isActive: boolean): Observable<any> {
    const path = `/holidays/exercises/`;
    const body = {
      active: isActive,
    };
    return this.apiService.buildAPIPut<any>(path, id, body);
  }

  getOperativeWeekConfigs(data: {
    operativa_id: number;
    exercise_id: number;
    year: number;
    week_numbers?: number[];
  }): Observable<OperativeWeekConfigsResponse> {
    const path = `/holidays/operativa-week-configs/`;
    return this.apiService.buildAPIPost<OperativeWeekConfigsResponse>(
      path,
      data
    );
  }

  syncWeekConfigs(data: {
    operativa_id: number;
    exercise_id: number;
  }): Observable<SyncWeekConfigsResponse> {
    const path = `/holidays/operativa-assignments/sync-weeks/`;
    return this.apiService.buildAPIPost<SyncWeekConfigsResponse>(path, data);
  }

  refreshWeekConfig(data: {
    operativa_id: number;
    exercise_id: number;
    week_numbers: number[];
  }): Observable<SyncWeekConfigsResponse> {
    const path = `/holidays/operativa-assignments/sync-weeks/`;
    return this.apiService.buildAPIPost<SyncWeekConfigsResponse>(path, data);
  }

  updateWeekConfig(
    id: number,
    data: {
      // camions_plaza?: number;
      camions_parats_objectiu?: number;
      slots?: number;
    }
  ): Observable<any> {
    const path = `/holidays/operativa-week-configs/`;
    return this.apiService.buildAPIPatch<any>(path, id, data);
  }

  getDriverAssignments(data: {
    operativa: number;
    exercise: number;
  }): Observable<DriverAssignmentResponse> {
    const path = `/holidays/driver-assignments/filter/`;
    return this.apiService.buildAPIPost<DriverAssignmentResponse>(path, data);
  }
}
